import React, {
    Component,
    createRef,
} from 'react'
import wrapperClickOutside from '../../../components/shared/wrapper-click-outside'
import OutsideClickHandler from 'react-outside-click-handler'

const DateIcon = '/images/date_icon_dark.svg'
const StarIcon = '/images/star-filter.png'
const KidsIcon = '/images/star-filter.png'
const SportsIcon = '/images/star-filter.png'
const CheerIcon = '/images/cheer_filter.png'
const InfoIcon = '/images/whistle.png'
const ArrowIconLeft = '/images/arrow-right-blue.svg'
const ArrowIconRight = '/images/arrow-right-blue.svg'
const LoaderIcon = '/images/loader.gif'

const AUTHED_USER = 'authedUser'

const mapStateToProps = state => ({
    authedUser: state.auth,
})

export {
    wrapperClickOutside,
    DateIcon,
    StarIcon,
    KidsIcon,
    SportsIcon,
    CheerIcon,
    InfoIcon,
    LoaderIcon,
    ArrowIconRight,
    ArrowIconLeft,
    mapStateToProps,
    AUTHED_USER,
}

/**
 * Close filter and start searching - pressed into HOC
 * USAGE:
 *
 *    * make sure, when filter module exports self (export default class Foo ...)
 *    * make sure, when filter opening state is "showSearch" and success action is "acceptSearch" - or define self as HOC params
 *
 * @searchOnClickOutside('showSearch', 'acceptSearch')
 *
 *
 * @param {string} toggleState - what param in state define, when filter is opening?
 * @param {string} toggleMethod - method name for closing filter
 * @return {function(*): Class}
 */
export function searchOnClickOutside(toggleState = 'showSearch', toggleMethod = 'acceptSearch') {
    return function(Child) {
        class Class extends Component {
            childContainer = createRef()

            /**
             * Render HOC
             *
             * @return {*}
             */
            render = () => (
                <OutsideClickHandler onOutsideClick={() => this?.childContainer?.current?.state?.[toggleState] ? this?.childContainer?.current?.[toggleMethod]?.() : {}}>
                    <Child {...this.props} {...this.context} ref={this.childContainer} />
                </OutsideClickHandler>
            )
        }

        return Class
    }
}
